import { useContext } from "react";
import { IGraduatesApplication } from "../types";
import { ApplicationContext } from "../../../../context/ApplicationContext";

export default function useSetGradsApplicationData() {
  const {
    onlineApplicationId,
    recurlyAccountId,
    setRecurlyAccountId,
    setOnlineApplicationId,
    setSecurityKey,
  } = useContext(ApplicationContext);

  return function setGradsApplicationData(
    data: Partial<IGraduatesApplication>
  ) {
    if (data?.id && onlineApplicationId !== data.id) {
      setOnlineApplicationId(data.id);
      setSecurityKey(data.securityKey);
    }

    if (data?.accountId && recurlyAccountId !== data.accountId) {
      setRecurlyAccountId(data.accountId);
    }
  };
}
